import React from 'react';
import cn from 'classnames';
import './Message.scss';

const Message = (props) => (
  <span
    className={cn('message-cham', props.className)}
    tabIndex={props.tabIndex}
    aria-label={props.ariaLabel}
  >
    {props.children}
  </span>
);

Message.displayName = 'Message';

export default Message;
